import { KomboApplicationStage } from "./kombo_application_stage";

export class KomboApplicationStages extends Array<KomboApplicationStage> {
  constructor(stages?: KomboApplicationStage[]) {
    super();
    if (stages instanceof Array) stages.forEach((stage) => this.push(stage));
  }
}
